const STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  IN_REVIEW: 'in_review',
  CLOSED: 'closed',
}

export { STATUS }
